
  import { defineComponent, inject, ref, Ref, computed } from 'vue';
  import { reportFromAnalyticsPageKey, reportIdFromAnalyticsPageKey } from '@/ui/injectionKeys';
  import { ReportRecordData } from '@/services/api/resources/analytics-builder/model';
  import SidebarHeader from '@/ui/components/analytics/sidebar/SidebarHeader.vue';
  import CopyButton from '@/ui/components/button/CopyButton.vue';
  import { router } from '@/ui/routes';
  import { user } from '@/ui/auth/auth';

  interface AnalyticsShareSidebarProps {
    isOpen: boolean;
  }

  export default defineComponent<AnalyticsShareSidebarProps>({
    components: { CopyButton, SidebarHeader },
    props: ['isOpen'],
    emits: ['close'],
    setup() {
      const id = inject<Ref<number | null>>(reportIdFromAnalyticsPageKey, ref(null));
      const report = inject<Ref<ReportRecordData | null>>(reportFromAnalyticsPageKey, ref(null));

      const url = computed(() => {
        const urlPath = router.resolve({
          name: 'analyticsReportEdit',
          params: {
            id: id?.value?.toString()!,
          },
        }).href;

        return `${process.env.VUE_APP_ADMIN_URL}${urlPath}`;
      });

      const guestUrl = computed(() => {
        if (!report.value?.obfuscatedId) {
          return null;
        }

        const guestPath = router.resolve({
          name: 'publicAnalyticsReport',
          params: {
            id: report.value.obfuscatedId.toString(),
          },
          query: {
            locale: user.value.locale,
          },
        }).href;

        return `${process.env.VUE_APP_ADMIN_URL}${guestPath}`;
      });

      return {
        url,
        guestUrl,
      };
    },
  });
